





const title_tbl = { textDecoration : 'underline' , fontWeight : '800'}
const box_border = { padding : 2 , border : '1px solid #EAECF0'}


export { title_tbl, box_border }